import React, { useState, useEffect } from 'react';
import './ContactPage.css'; // We can reuse some of the contact page styling
import './Makeoffer.css'; // Reuse modal overlay styles
import { CONTACT_API_URL, hasContactApi } from './api';
import emailjs from '@emailjs/browser';

const ContactUsOverlay = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [justSent, setJustSent] = useState(false);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      // Reset form when modal opens
      setFormData({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
      });
      setShowSuccess(false);
      setIsSubmitting(false);
      setJustSent(false);
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { name, email, phone, subject, message } = formData;

    setIsSubmitting(true);

    if (hasContactApi()) {
      try {
        const res = await fetch(CONTACT_API_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ name, email, phone, subject, message }),
        });
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.error || `Request failed: ${res.status}`);
        }
        handleSuccess();
      } catch (err) {
        console.error('Contact submit failed:', err);
        handleFailure();
      }
      return;
    }

    // Fallback to EmailJS for free hosting
    try {
      const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID || 'your_service_id';
      const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID || 'your_template_id';
      const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY || 'your_public_key';
      
      const templateParams = {
        from_name: name,
        from_email: email,
        phone: phone,
        subject: subject,
        message: message,
        to_email: 'abhi@auzlandre.com.au'
      };

      await emailjs.send(serviceId, templateId, templateParams, publicKey);
      handleSuccess();
    } catch (err) {
      console.error('EmailJS send failed:', err);
      handleFailure();
      alert('Failed to send message. Please try again or contact us directly.');
    }
  };

  const handleSuccess = () => {
    setShowSuccess(true);
    setJustSent(true);
    setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
    setTimeout(() => {
        onClose();
        setShowSuccess(false);
        setJustSent(false);
        setIsSubmitting(false);
    }, 2000);
  };

  const handleFailure = () => {
    setIsSubmitting(false);
  }

  if (!isOpen) {
    return null;
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="offer-modal" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close-btn" onClick={onClose}>
          &times;
        </button>
        
        <div className="offer-header">
          <h3>Contact Us</h3>
          <p>Get in touch with our team for any inquiries or assistance</p>
        </div>

        {showSuccess ? (
            <div className="offer-success">
                <h4>Thank You!</h4>
                <p>Your message has been sent successfully.</p>
            </div>
        ) : (
            <form className="contact-form card" onSubmit={handleSubmit} style={{padding: 0, boxShadow: 'none'}}>
                <div className="form-group">
                <label htmlFor="name">Full Name *</label>
                <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="Enter your full name"
                />
                </div>
                
                <div className="form-group">
                <label htmlFor="email">Email Address *</label>
                <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="Enter your email address"
                />
                </div>
                
                <div className="form-group">
                <label htmlFor="phone">Phone Number *</label>
                <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    placeholder="Enter your phone number"
                />
                </div>
                
                <div className="form-group">
                <label htmlFor="subject">Subject *</label>
                <select
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                >
                    <option value="">Select a subject</option>
                    <option value="general">General Inquiry</option>
                    <option value="buying">Buying Property</option>
                    <option value="selling">Selling Property</option>
                    <option value="renting">Renting Property</option>
                    <option value="valuation">Property Valuation</option>
                    <option value="other">Other</option>
                </select>
                </div>
                
                <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="5"
                    placeholder="Tell us how we can help you..."
                ></textarea>
                </div>
                
                <button
                type="submit"
                className={`btn-modern ${isSubmitting ? 'loading' : ''} ${justSent ? 'success' : ''}`}
                disabled={isSubmitting}
                aria-live="polite"
                >
                {isSubmitting && (
                    <span className="spinner" aria-hidden="true"></span>
                )}
                {justSent && !isSubmitting && (
                    <span className="icon-check" aria-hidden="true">✓</span>
                )}
                <span className="label">
                    {isSubmitting ? 'Sending' : justSent ? 'Sent!' : 'Send Message'}
                </span>
                </button>
            </form>
        )}
      </div>
    </div>
  );
};

export default ContactUsOverlay;
